export default class SubjectContactEntity {

    constructor() {
        this.id = ''
        this.subject = ''
        this.main = false
        this.contractMain = false
        this.name = ''
        this.email = ''
        this.phone = ''
        this._action = null
    }

    /**
     * @param response : object
     * @returns SubjectContactEntity
     */
    static from(response) {
        let obj = new this
        obj.id = response.id
        obj.subject = response.subject
        obj.main = response.main
        obj.contractMain = response.contractMain
        obj.name = response.name ?? ''
        obj.email = response.email ?? ''
        obj.phone = response.phone ?? ''

        return obj
    }

}
